import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import type { AgentEntity } from '@tradecafe/aiagent-sdk';
import type { DeepReadonly } from '@tradecafe/types/utils';
import * as AgentActions from './agent.actions';

export const agentsFeatureKey = 'agents'
export interface AgentsState extends EntityState<DeepReadonly<AgentEntity>> {
}

export const selectId = (agent: AgentEntity) => agent.agent_id
export const adapter = createEntityAdapter<DeepReadonly<AgentEntity>>({ selectId })

const initialState: AgentsState = adapter.getInitialState({
})

export const agentsReducer = createReducer(
  initialState,
  on(AgentActions.loadAgentsSuccess,
    (state, action) =>
      adapter.upsertMany(action.agents, state)),
  on(AgentActions.createAgentSuccess,
    (state, action) =>
      adapter.upsertOne(action.agent, state)),
  on(AgentActions.cloneAgentSuccess,
    (state, action) =>
      adapter.upsertOne(action.agent, state)),
  on(AgentActions.updateAgentSuccess,
    (state, action) =>
      adapter.upsertOne(action.agent, state)),
)

